/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var DocEditIcon16Solid = forwardRef('DocEditIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M8 1H4.5A2.5 2.5 0 0 0 2 3.5v9A2.5 2.5 0 0 0 4.5 15h2v-.672a2 2 0 0 1 .586-1.414L13 7V6H9.5A1.5 1.5 0 0 1 8 4.5V1Z" }),
        React.createElement("path", { d: "M13 5 9 1v3.5a.5.5 0 0 0 .5.5H13Z" }),
        React.createElement("path", { d: "M8 14.414V15.5a.5.5 0 0 0 .5.5h1.086a1 1 0 0 0 .707-.293l3.804-3.804-2-2-3.804 3.804a1 1 0 0 0-.293.707Z" }),
        React.createElement("path", { d: "m15.682 10.318-.878.878-2-2 .878-.878a1 1 0 0 1 1.414 0l.586.586a1 1 0 0 1 0 1.414Z" })));
});
